{
    "work_email": "Geschäftliche Email-Adresse",
    "password": "Passwort",
    "new_password": "Neues Passwort",
    "confirmPassword": "Bestätige Passwort",
    "confirm_new_password": "Neues Passwort bestätigen",
    "per_page_option": "{{rows}} Zeilen anzeigen",
    "message": "Nachricht",
    "find_sub_company": "Finde deine Firma",
    "fallback_approver": "Ersatz-Genehmiger:in",
    "request": {
        "kind": "Kostenart",
        "name": "Name",
        "link": "Abonnement URL",
        "currency": "Währung",
        "monthly": "Monatlich",
        "quarterly": "Quartalsweise",
        "yearly": "Jährlich",
        "monthly_price": "Monatli. Preis",
        "quarterly_price": "Quartals-Preis",
        "yearly_price": "Jahres-Preis",
        "description": "Beschreibung",
        "performance_date": "Leistungsdatum",
        "date_started": "Startdatum",
        "date_cancellation_due": "Vertragsverlängerungsdatum",
        "billing_period": "Abrechnungszeitraum",
        "item_name": "Artikel",
        "total_price": "Gesamtpreis",
        "line_items": "Artikel",
        "quantity": "Menge",
        "unit_of_measure": "Einheit",
        "unit_price": "Einzelpreis",
        "cost_center": "Kostenstelle",
        "vendor": "Lieferant",
        "approval_needed_by": "Genehmiger:in",
        "requested_by": "Beantragt von",
        "invoice": "Rechnung",
        "delivery_note": "Lieferschein",
        "invoice_number": "Rechnungsnummer",
        "invoice_date": "Rechnungsdatum",
        "invoice_due_date": "Fällig am",
        "subscription": "Abonnement",
        "tax": "MwSt.",
        "tax_rate": "MwSt. (%)",
        "date_paid_at": "Bezahlt am",
        "expense_account": "Sachkonto",
        "payment_option": "Zahlungsart",
        "offer": "Angebot",
        "total_net_amount": "Netto Ges.",
        "total_tax": "MwSt. Ges.",
        "total_gross_amount": "Brutto Ges.",
        "net_unit_price": "Netto Pos.",
        "total_net": "Netto",
        "quantity_short": "Stk.",
        "execution_date": "Ausführungsdatum",
        "due_on_extra": "Fällig am: {{dueOn}}",
        "workflow": "Workflow",
        "next_approver": "Nächste:r Genehmiger:in",
        "recurring_expense_approval_process": "Freigabe wiederkehrende Anträge",
        "net_price": "Netto",
        "gross_price": "Brutto",
        "tax_price": "MwSt.",
        "date": "Datum",
        "billable": "Weiterverrechenbar",
        "mileage": {
            "return_from_destination": "Rückkehr vom Zielort",
            "invoice_number": "Eigenbelegnummer",
            "date": "Datum der Fahrt",
            "vehicle": "Fahrzeug (Kilometerpauschale)",
            "vehicle_type": {
                "car": "Auto",
                "motorcycle": "Motorrad"
            },
            "distance": "Entfernung",
            "start_address": "Startadresse",
            "destination_address": "Zieladresse",
            "reason": "Beschreibung/Anlass der Fahrt",
            "total_calculated_amount": "Erstattungsfähiger Gesamtbetrag",
            "additional_stop": "Zusätzlicher Halt",
            "additional_stop_x": "{{nth}} zusätzlicher Halt",
            "additional_distance_reason": "Grund für die zusätzliche Entfernung"
        },
        "per_diem": {
            "breakfast": "Frühstück",
            "lunch": "Mittagessen",
            "dinner": "Abendessen",
            "accommodation": "Unterkunft",
            "destination": "Land",
            "nth_destination": "{{nth}} Land",
            "start_date": "Startdatum",
            "return_date": "Rückkehrdatum",
            "time": "Zeit",
            "start_time": "Startzeit",
            "return_time": "Endzeit",
            "transfer_date": "Weiterreisedatum",
            "transfer_time": "Zeit",
            "add_destination": "Weiteres Land hinzufügen",
            "reason": "Beschreibung/Anlass der Dienstreise"
        },
        "hospitality": {
            "merchant": "Bewirtungsstätte",
            "tip": "Trinkgeld",
            "date": "Datum der Bewirtung",
            "attendees": "Teilnehmer",
            "reason": "Beschreibung/Anlass der Bewirtung"
        },
        "payment_flow_information": {
            "title": "Bezahlungsstatus",
            "not_set": "Nicht gesetzt",
            "already_paid": "Bereits bezahlt (z.B. SEPA)",
            "already_approved_and_paid": "Bereits genehmigt & bezahlt",
            "reporting_only": "Nur für Reporting"
        },
        "renewal_generation": {
            "title": "Generierung von wiederkehrenden Anträgen",
            "by_date": "Mittels Datum",
            "by_transaction": "Mittels Transaktion"
        },
        "folder": {
            "trip_date": "Startdatum",
            "time": "Zeit",
            "return_date": "Rückkehrdatum",
            "destination": "Hauptzielort (Stadt)",
            "folder_name": "Bezeichnung der Reise"
        },
        "subscriptions": {
            "paused": "Pausierte Abonnements",
            "active": "Aktive Abonnements"
        }
    },
    "vendor": {
        "name": "Lieferantenname (kurz)",
        "nameExtended": "Lieferantenname (vollständig)",
        "rating": "Bewertung",
        "description": "Beschreibung",
        "recommendation": "Empfehlung",
        "street_name": "Straße",
        "street_number": "Hausnummer",
        "zip": "PLZ",
        "city": "Stadt",
        "country": "Land",
        "contact_person_name": "Kontaktperson Name",
        "contact_person_email": "Kontaktperson Email-Adresse",
        "contact_person_phone": "Kontaktperson Mobiltelefonnummer",
        "tax_number": "Steuernummer",
        "vat_number": "Umsatzsteuer-ID",
        "iban": "IBAN",
        "bic": "BIC",
        "account_number": "Kontonummer",
        "sort_code": "Bankleitzahl",
        "company_logo": "Firmenlogo",
        "creditor_number": "Kreditorennummer",
        "recommendations": {
            "fine": "zu empfehlen",
            "blacklisted": "gesperrt"
        }
    },
    "employee": {
        "has_system_rights": "Systemadministrationsrechte",
        "company": "Firma",
        "first_name": "Vorname",
        "last_name": "Nachname",
        "email": "Email-Adresse",
        "location": "Standort",
        "work_phone": "Mobiltelefonnummer",
        "profile_picture": "Profilbild",
        "position": "Position",
        "personioTooltip": "Diese Information wurden von Personio importiert.",
        "team": "Abteilung",
        "role": "Rolle",
        "superior": "Vorgesetzte",
        "date_of_birth": "Geburtsdatum",
        "hired_date": "Einstellungsdatum",
        "limit": "Bis zu",
        "approver": "Freigeber:in",
        "roles": {
            "employee": "Antragsteller:in",
            "approver": "Genehmiger:in",
            "admin": "Admin"
        },
        "mileage_rate": "Individueller Kilometersatz (ct/km)",
        "show_add_user_to_company_fields": "Benutzer:in zu Firma hinzufügen und Einladungs-E-Mail senden"
    },
    "employee_absence": {
        "period": "Abwesenheitszeitraum"
    },
    "cost_center": {
        "name": "Kostenstelle",
        "id": "Kostenstelle ID",
        "responsible_user": "Verantwortliche Person",
        "shared_users": "Teilen mit",
        "shared_with": "Geteilt mit",
        "shared_users_all_option_label": "Alle",
        "shared_users_people_counter_label": "Mitarbeiter:innen",
        "default_budget_value": "Standardbudget",
        "alternative_budget": "Abweichendes Budget",
        "default_budget_currency": "Budget Währung",
        "monthly": "Monatlich",
        "quarterly": "Quartalsweise",
        "yearly": "Jährlich",
        "budget_value": "Budgetwert",
        "budget_period": "Budgetzeitraum",
        "budget": {
            "status": "Ausgaben im Vergleich zur Prognose",
            "above_budget": "Über budget",
            "within_budget": "Im budget"
        }
    },
    "cost_center_filter": {
        "starting_date": "Startdatum",
        "ending_date": "Enddatum"
    },
    "settings": {
        "global_currency": "Währung",
        "show_expense_numbers": "Nummerierung für Ausgaben anzeigen",
        "enable_ocr": "OCR aktivieren",
        "enable_ocr_itemization": "OCR Artikel-Erkennung aktivieren",
        "enable_go_to_next_expense": "Freigabe: Navigation zum nächsten Antrag",
        "enable_email_notifications": "Email-Benachrichtigungen aktivieren",
        "show_gross": "Bruttobeträge anzeigen",
        "ocr": "OCR",
        "archiveExpensesAfterXDays": "Ausgaben automatisch archivieren nach (Tage)",
        "archiveTransactionsAfterXDays": "Transaktionen automatisch archivieren nach (Tage)",
        "inline_items": "Artikel",
        "csv_delimiter": "CSV-Trennzeichen",
        "role_name": "Rollenbezeichnung",
        "number_separator": "CSV-Dezimaltrennzeichen",
        "show_stamp": "Stempel zeigen",
        "default_role_profile": "Wählen Sie eine Standardrolle als Grundlage für diese individuelle Rolle"
    },
    "company_settings": {
        "po_skip_procurement": "Einkaufsfreigabe für Bestellungen überspringen",
        "logo": "Firmenlogo",
        "name": "Firmenname",
        "companyIdentifier": "Firmenidentifikation",
        "bic": "BIC",
        "iban": "IBAN",
        "default_creditor_number": "Standard Kreditorennummer",
        "default_employee_creditor_number": "Standard Mitarbeiter Kreditorennummer",
        "card_feature": "Kartenfunktionen",
        "liquidity_management_feature": "Liquiditäts-Funktion",
        "auto_match_feature": "Automat. Matching von Transaktionen",
        "allow_cost_center_2_creation": "Kostenträgererstellung erlauben",
        "allow_workflow_adjustments": "Workflow-Anpassungen erlauben",
        "is_lexware_export_enabled": "Lexware CSV Export",
        "is_non_sepa_xml_export_enabled": "NON SEPA XML Export",
        "is_sepa_xml_bulgaria_enabled": "SEPA XML (Bulgarien)",
        "add_audit_trail_to_invoice_export": "Audit-Protokoll als zusätzliche Datei mit Rechnung anhängt",
        "address_line": "Straßenname und -nummer",
        "city": "Stadt",
        "country": "Ländercode (zwei Buchstaben, z.B. DE)",
        "zip": "PLZ",
        "sameAsBusinessAddress": "Gleiche Adresse wie Geschäftsadresse",
        "tagging_feature": "Tagging-Funktion",
        "allow_all_to_update_absences": "Alle können ihre Abwesenheiten aktualisieren",
        "enable_edit_rights": "Taggings Schreibrecht für alle",
        "payment_flow_information": {
            "already_approved_and_paid": "\"Genehmigt & bezahlt\"-Prozess",
            "already_paid": "\"Bereits bezahlt\"-Prozess",
            "reporting_only": "\"Nur Reporting\"-Prozess"
        },
        "vendor_rules_should_overwrite": "Lieferanten-Regeln haben Vorrang vor Mitarbeiterregeln",
        "show_cost_centers_ids": "Kostenstellen IDs in Drop-down-Menüs anzeigen",
        "vendor_creation_for_all": "Lieferantenerstellung durch alle Nutzer:innen",
        "show_auto_approver_warning": "Auto-Approver Warnung",
        "invoice_auto_match_feature": "Automat. Matching von Inbox-Rechnungen",
        "distance_buffer": "Distanzpuffer in Kilometer (km)",
        "recalculate_approval_process_after_amount_changes": "Freigabeprozess zurücksetzen und neu berechnen, wenn sich der Betrag in einem Antrag verändert.",
        "recalculate_approval_process_after_folder_amount_changes": "Freigabeprozess zurücksetzen und neu berechnen, wenn sich der Betrag in einer Reise verändert.",
        "recalculate_approval_process_after_other_changes": "Freigabeprozesses für andere Änderungen in einem Antrag zurücksetzen und neu berechnen",
        "recalculate_approval_process_after_folder_other_changes": "Freigabeprozess zurücksetzen und neu berechnen, wenn sich bestimmte Daten in einer Reise verändern",
        "multi_currency_wallet": "Wallet in verschiedenen Währungen",
        "enforce_belegfunktion": "GoBD-konformes Arbeiten",
        "timezone": "Zeitzone",
        "default_employee_language": "Standardsprache für Mitarbeiter:innen",
        "update_sepa_version": "SEPA xml Version (pain.001.001.09)",
        "is_skr42_enabled": "SKR42 (Vereine)"
    },
    "export": {
        "payment": "Zahlung",
        "only_paid_requests": "Nur bezahlte Anträge",
        "only_all_docs": "Nur Anträge mit vollständigen Dokumenten",
        "start_date": "Startdatum",
        "end_date": "Enddatum",
        "format": "Format",
        "change_history": {
            "resource": "Ressource",
            "period": "Zeitraum des Änderungsprotokoll"
        },
        "export_format": {
            "all": "Alle Formate",
            "all_formats": "Alle Formate",
            "csv": "CSV",
            "change_history": "Änderungsprotokoll",
            "lexware_csv": "Lexware CSV",
            "csv_lexware": "Lexware CSV",
            "datev_invoice_csv": "DATEV Beleg CSV",
            "datev": "DATEV XML",
            "invoices": "Rechnungen",
            "datev_online": "DUO",
            "sepa": "SEPA-XML",
            "non_sepa": "NON-SEPA-XML",
            "mark_as_done": "Erledigt markieren",
            "audit_trail": "Audit-Protokoll",
            "internal_receipt": "Eigenbeleg"
        }
    },
    "payment_info": {
        "subscription_plan": "Abonnementplan",
        "billing_name": "Name für Rechnungsstellung",
        "billing_email": "Email-Adresse",
        "yearlyPlan": "Jährliche Zahlung",
        "monthlyPlan": "Monatliche Zahlung",
        "card_details": "Zahlungsart"
    },
    "banking": {
        "search_term": "Begriffssuche",
        "payment_account": "Bezahlungsaccount",
        "default_connection": "Standardverbindung",
        "custom_name": "Bankname",
        "bank_account": "Bankaccount",
        "yes": "Ja",
        "no": "Nein",
        "amounts_mismatch": {
            "title": "Buchhaltungsabweichung erkannt",
            "checkbox": "Die Werte dieses Antrags entsprechen nicht den standardmäßigen Buchhaltungsgrundsätzen. Die NETTO-, MWST- und BRUTTO-Werte stimmen nicht überein. Möchten Sie diese Transaktion dennoch genehmigen?"
        }
    },
    "expense_account": {
        "account_name": "Name",
        "account_code": "Code"
    },
    "cost_center_2": {
        "name": "Name",
        "code": "ID"
    },
    "filter_form": {
        "amount": "Betrag",
        "budget": "Budget",
        "min_amount": "Min",
        "max_amount": "Max",
        "time_interval": "Zeitintervall",
        "from": "Von",
        "to": "Bis",
        "all": "Alle",
        "vendor": "Lieferant",
        "team": "Abteilung",
        "role": "Rolle",
        "not_set": "Nicht gesetzt",
        "date_purchased": "Gekauft am",
        "due_date": "Fällig am",
        "due_in_days": "Fällig in",
        "days": "Tagen",
        "starting_date": "Startdatum",
        "ending_date": "Enddatum",
        "iban": "IBAN",
        "description": "Beschreibung",
        "probability_range": "Wahrscheinlichkeit",
        "min_probability": "Min",
        "max_probability": "Max",
        "cost_center": "Kostenstelle",
        "cost_center_2": "Kostenträger",
        "expense_account": "Sachkonto",
        "billing_period": "Abrechnungszeitraum",
        "card_attached": "Karte hinterlegt",
        "card_program_enrolled": "Kartenprogramm aktiv",
        "tfa_enabled": "Zwei-Faktor-Authentifizierung aktiviert",
        "phone_number_verified": "Telefonnummer verifiziert",
        "superior_set": "Vorgesetzte:r gesetzt",
        "payment_data_added": "Zahlungsdaten hinterlegt",
        "expenses_so_far": "Bisherige Kosten",
        "vendor_rules_set": "Lieferanten regeln",
        "contract_set": "Vertrag hinterlegt",
        "tax_set": "Steuernummer hinterlegt",
        "vat_set": "Umsatzsteuer-ID hinterlegt",
        "recommendation": "Empfehlung hinterlegt",
        "creditor_number_range": "Kreditorennummer",
        "status": "Status"
    },
    "card_filter": {
        "cardType": "Kartenart",
        "mode": "Kartentyp",
        "card_holder": "Kartenhalter",
        "limit": "Karten limit",
        "status": "Status",
        "window": "Zeitintervall",
        "subscription_attached": "Abonnement aktiv",
        "team": "Kartenhalter team"
    },
    "expense_filter": {
        "kind": "Kostenart",
        "cost_center": "Kostenstelle",
        "cost_center_2": "Kostenträger",
        "expense_account": "Sachkonto",
        "time_interval": "Zeitintervall",
        "min_date": "Von",
        "max_date": "Bis",
        "requester": "Antragssteller:in",
        "expenseTags": "Tag",
        "status": "Status",
        "date_range": "Zeitrahmen",
        "date_paid_at": "Bezahlt am",
        "purchase_date_range": "Leistungsdatumsbereich",
        "invoice_date_range": "Rechnungsdatumsbereich",
        "starting_date": "Startdatum",
        "ending_date": "Enddatum",
        "approver": "Genehmiger:in",
        "export_format": {
            "title": "Export Format",
            "csv": "Exportiert als CSV (inkl. Komplett-Exporte)",
            "not_csv": "Nicht exportiert als CSV (exkl. Komplett-Exporte)",
            "datev_xml": "Exportiert als DATEV XML",
            "not_datev_xml": "Nicht exportiert als DATEV XML",
            "datev_invoice_csv": "Exportiert als DATEV Beleg CSV",
            "not_datev_invoice_csv": "Nicht exportiert als DATEV Beleg CSV",
            "datev_online": "Exportiert nach DUO",
            "not_datev_online": "Nicht exportiert nach DUO",
            "all_datev": "Exportiert nach DUO oder DATEV XML",
            "not_all_datev": "Nicht exportiert nach DUO und DATEV XML"
        },
        "comments_and_mentions": {
            "title": "Kommentare & Erwähnungen",
            "my_comments": "Meine Kommentare",
            "my_mentions": "Meine Erwähnungen"
        },
        "include_archived": "Archivierte berücksichtigen",
        "billable": {
            "title": "Weiterverrechenbar",
            "true": "Ja",
            "false": "Nein"
        }
    },
    "inbox_filter": {
        "min_upload_date": "Von",
        "max_upload_date": "Bis",
        "uploaded_by": "Hochgeladen von",
        "not_set": "Nicht gesetzt",
        "upload_date_range": "Hochladedatum"
    },
    "transaction_filter": {
        "transaction_date_range": "Transaktionsdatum",
        "transaction_status": "Transaktionsstatus",
        "transaction_matched": "Matching Status",
        "transaction_type": "Transaktionsart",
        "bank_account": "Bankkonto"
    },
    "reporting_filter": {
        "cost_center": "Kostenstelle",
        "min_date": "Von",
        "max_date": "Bis",
        "date_range": "Zeitrahmen",
        "purchase_date_range": "Leistungsdatumsbereich",
        "invoice_date_range": "Rechnungsdatumsbereich",
        "starting_date": "Startdatum",
        "ending_date": "Enddatum"
    },
    "employee_filter": {
        "min_expenses": "Min kosten",
        "max_expenses": "Max kosten"
    },
    "matching": {
        "expense_id": "Antrags ID",
        "csv": {
            "csv_name": "CSV Name",
            "change_sign": "Vorzeichen wechseln",
            "mapping": {
                "amount": "Betrag",
                "date": "Datum",
                "description": "Beschreibung",
                "description_and_iban": "Beschreibung (+ IBAN)",
                "vendor": "Lieferant",
                "iban": "IBAN",
                "currency": "Währung",
                "none": "-"
            },
            "amount_option": {
                "title": "Welche Beträge sollen berücksichtigt werden?",
                "negative": "Negative",
                "positive": "Positive",
                "all": "Alle"
            }
        }
    },
    "kyb": {
        "company_name": "Company name",
        "trading_name": "Company trading name",
        "establishment_date": "Date of establishment",
        "tax_id": "Tax ID",
        "incorporation_type": "Incorporation type",
        "incorporation_state": "State of incorporation",
        "incorporation_certificate": "Certificate of incorporation",
        "is_public": "Is public or not",
        "yes": "Yes",
        "no": "No",
        "is_payment_provider": "Is payment provider",
        "primary_contact_email": "Email of primary contact",
        "primary_contact_phone": "Mobile number of primary contact",
        "address_company": "Address of the company",
        "address_office": "Office address",
        "street": "Street",
        "street_number": "Street number",
        "city": "City",
        "state": "State",
        "postal_code": "Postal Code",
        "country_code": "Country Code",
        "legal_structure_chart": "Legal structure chart",
        "financial_statement": "Financial statement",
        "memorandum": "Memorandum / Article of association",
        "title": "Directors or officers",
        "legal_rep_information": "Legal representative information",
        "first_name": "First name",
        "last_name": "Last name",
        "job_title": "Job title",
        "date_of_birth": "Date of birth",
        "phone": "Phone number",
        "email": "Email address",
        "is_owner": "Is also beneficial owner",
        "owner": "Yes",
        "not_owner": "No",
        "personal_id": "National ID or driver's license",
        "proof_of_address": "Proof of address",
        "proof_of_address_extra": "Eg., bank statement or utility bill. Must be dated within last 3 months.",
        "add": "Add another beneficial owner",
        "remove": "Remove beneficial owner",
        "date_appointed": "Date appointed",
        "nationality": "Nationality",
        "is_beneficial_owner": "Is also beneficial owner",
        "is_proprietor_or_officer": "Is also proprietor or officer",
        "address_of_legal_representative": "Address of the legal representative",
        "identification": "Identification of the director",
        "identification_type": "Type of the identification document",
        "identification_value": "ID or passport number",
        "identification_type_id": "National ID",
        "identification_type_passport": "Passport",
        "shareholder_information": "Shareholder information",
        "company_owner_percentage": "Company owner percentage",
        "attester_name": "Attester name",
        "attestation_date": "Attestation date",
        "official_document": "Official or notarized document of share ownership shows the ultimate shareholders",
        "attestation_consent": "Attestation consent",
        "shares_of_company": "Company ownership percentage",
        "wallet_base_currency": "Grundwährung des Wallets und der Karten",
        "wallet_base_currency_note": "Dies kann im Nachhinein nicht mehr geändert werden. Falls Sie sich unsicher sind, wenden Sie sich bitte an unseren Support."
    },
    "card": {
        "limit": "Limit",
        "frequency": "Frequenz",
        "transaction_limit": "Transaktionslimit",
        "atm_withdrawals": "Geldautomatenentnahmen",
        "cashback_enabled": "Cashback aktiviert",
        "auto_recharge_enabled": "Automatische Aufladung",
        "card_name": "Kartenname oder -beschreibung",
        "mode": {
            "mode": "Kartenart",
            "prepaid_mode": "Prepaid",
            "debit_mode": "Debit"
        },
        "bin_type": {
            "title": "Kartenkonfiguration",
            "german_bin": "Deutsche BIN",
            "bulgarian_bin": "Nicht-Deutsche BIN"
        },
        "limit_change_approver": "Änderungs-Genehmiger:in begrenzen",
        "limit_change_amount": "Gewünschter Limit-betrag für diese Karte",
        "limit_change_reason": "Bitte geben Sie den Grund für die Änderung des Limits an.",
        "delivery_type": {
            "title": "Zustellungsmethode",
            "standard_delivery": "Standard",
            "registered_mail": "Sendungsverfolgung mit Einschreiben",
            "courier": "Kurier",
            "first_class_mail": "Sendungsverfolgung"
        },
        "renewal_generation_for_sub_card": "Generierung von wiederkehr. Anträgen für Abonnement",
        "should_update_expense_amount_on_card_transaction": "Autom. Antragsbeträge anpassen",
        "name_on_card": "Name auf der Karte",
        "cannot_be_changed_after_creation": "Kann nach der Erstellung nicht mehr geändert werden"
    },
    "corporate": {
        "primary_contact_position": "Ihre Position in der Firma",
        "primary_contact_mobile": "Ihre Mobilnummer",
        "pin": "Ihre gewünschte finway PIN",
        "industry_type": "Industrie Typ",
        "source_of_funds": "Herkunft der Mittel",
        "source_of_funds_other": "Informationen über andere Herkunft der Mittel",
        "enroll_all_admins": "Alle Admins ins Kartenprogramm mitaufnehmen."
    },
    "wallet": {
        "amount": "Auszahlungsbetrag",
        "currency": "Währung",
        "beneficiary_name": "Name des Begünstigten",
        "beneficiary_address": "Adresse des Begünstigten",
        "bank_name": "Name der Bank",
        "bank_address": "Adresse der Bank",
        "bank_country": "Land der Bank",
        "verification_code": "Verifizierungscode",
        "description": "Beschreibung"
    },
    "tax": {
        "tax_rate": "MwSt.-Satz in %",
        "bu_code": "BU Nummer",
        "bu_code_name": "BU Name",
        "default": "Standard"
    },
    "team": {
        "team_name": "Abteilung"
    },
    "workflow": {
        "name": "Name",
        "cost_center": "Kostenstelle",
        "vendor": "Lieferant",
        "user": "Antragssteller:in",
        "approver": "Genehmiger:in",
        "responsible_employee": "Kostenstellenverantwortliche:r",
        "auto_approver": "Auto Approver",
        "superior": "Vorgesetzte:r des/r Antragssteller:in",
        "requester": "Antragssteller:in",
        "scope": {
            "all": "Alle",
            "purchase": "Kaufantrag",
            "invoice": "Rechnungsantrag",
            "reimbursement": "Rückerstattung",
            "scope": "Gültigkeit"
        },
        "request_type": {
            "title": "Antragstyp",
            "all": "Alles",
            "purchase": "Abonnement / Kaufantrag",
            "subscription": "Abonnement",
            "invoice": "Rechnungsantrag",
            "all_reimbursements": "Alle Erstattungen",
            "standard_reimbursement": "Standarderstattung",
            "reimbursement": "Rückerstattung",
            "hospitality_reimbursement": "Bewirtungserstattung",
            "mileage_reimbursement": "Kilometerpauschale",
            "per_diem_reimbursement": "Verpflegungsmehraufwand",
            "trip_folder": "Reise",

            "purchase_order": "Bestellungen"
        },
        "trigger": {
            "trigger_type": "Auslösetyp",
            "trigger_objects": "Auslöser",
            "requester": "Antragsteller:in",
            "vendor": "Lieferant",
            "cost_center": "Kostenstelle",
            "cost_center_2": "Kostenträger",
            "amount": "Nettobetrag",
            "amount_greater": "Nettobetrag >",
            "all": "Alle"
        },
        "operator": {
            "and": "Und",
            "or": "Oder"
        },
        "condition": {
            "net_amount_bigger": "Wenn Netto >"
        },
        "then": "Dann",
        "add_trigger_type": "UND Auslösetyp hinzufügen",
        "expense_type": "Antragsart",

        "recalculate_approval_processes_in_progress": "Aktive Genehmigungsprozesse neu berechnen, die mit diesem Workflow erstellt wurden. Dadurch werden die Genehmigungsprozesse zurückgesetzt.",
        "recalculate_also_approval_processes_in_progress": "Auch aktive Genehmigungsprozesse neu berechnen."
    },
    "liquidity": {
        "scenario": {
            "name": "Szenario-Name",
            "color": "Szenario-Farbe",
            "main": "Szenario",
            "sub": "Sub-Szenario",
            "parent": "Haupt-Szenario"
        },
        "planned_transaction": {
            "onetime": "Einmalig",
            "recurring": "Wiederkehrend",
            "title": "Beschreibung",
            "quantity": "Menge",
            "amount": "Betrag",
            "currency": "Währung",
            "category": "Kategorie",
            "start_date": "Startdatum",
            "end_date": "Enddatum",
            "frequency": "Frequenz",
            "monthly": "Monatlich",
            "quarterly": "Quartalsweise",
            "yearly": "Jährlich",
            "apply_all": "Auf alle Szenarien anwenden"
        }
    },
    "payment_settings": {
        "more_than": "Mehr als",
        "monthly_invoices": "monatliche Rechnungen"
    },
    "transaction_category": {
        "add": "Hinzufügen",
        "edit": "Bearbeiten",
        "delete": "Löschen"
    },
    "archive": {
        "searchPeriod": "Archivzeitraum"
    },
    "integrations": {
        "get_my_invoices": {
            "user_id": "GetMyInvoices Konto-ID"
        }
    },
    "passcode": {
        "update": {
            "old_passcode": "Alte finway PIN",
            "new_passcode": "Neue finway PIN"
        }
    },
    "follow_up": "Wiedervorlage",
    "email_alias_for": "Email-Alias für ",
    "alternative_email_for": "Alternative Email für ",
    "csv_settings": {
        "new_template_name": "Name",
        "select_template_name": "Wählen Sie eine vorhandenes Template als Vorlage aus",
        "field_individualisation": "Feld Individualisierung",
        "field_add": "Neues Feld",
        "edit_template_name": "Zu bearbeitende Vorlage",
        "rename_template": "Template umbenennen"
    },
    "custom_bank_subject": {
        "title": "Verwendungszweckvorlage (max. 140 Zeichen bei SEPA erlaubt)",
        "invoice_number": "Rechnungsnummer",
        "expense_number": "Ausgabennummer",
        "vendor_name": "Lieferant",
        "description": "Beschreibung",
        "request_items": "Antragsartikel",
        "not_set": "Nicht gesetzt"
    },
    "data_upload": {
        "errorsList": "Fehler",
        "created": "Erstellt",
        "restored": "Wiederhergestellt",
        "ignored": "Ignoriert",
        "teams": "Teams",
        "employees": "Mitarbeiter:innen",
        "group_cost_centers": "Kostenstellengruppen",
        "cost_centers": "Kostenstellen",
        "cost_centers_2": "Kostenträger",
        "expense_accounts": "Sachkonten",
        "vendors": "Lieferanten",
        "subscriptions": "Abonnements",
        "history_tab": "Import-Historie",
        "import_tab": "Daten importieren"
    },
    "custom_datev_info": {
        "one_time_no_items": "Einmalige Kosten - ohne Artikel",
        "one_time_with_items": "Einmalige Kosten - mit Artikel",
        "subscriptions": "Abonnements",
        "reimbursement_no_items": "Rückerstattung - ohne Artikel",
        "reimbursement_with_items": "Rückerstattung - mit Artikel",
        "invoiceNumber": "Rechnungsnummer",
        "finwayExpenseNumber": "finway Antragsnummer",
        "vendor": "Lieferant",
        "description": "Beschreibung",
        "items": "Artikel",
        "not_set": "Nicht ausgewählt",
        "subscriptionName": "Abonnement-Name",
        "employeeName": "Mitarbeiter:in",
        "reimbursementType": "Rückerstattungsart",
        "expenseType": "Antragsart",
        "all_expense": "Alle Ausgaben",
        "discount": "Skonto"
    },
    "sso": {
        "client_id": "Client ID",
        "client_secret": "Client secret",
        "tenant_domain": "Tenant domain"
    },
    "personio": {
        "client_id": "Client ID",
        "client_secret": "Client secret"
    },
    "one_time_expense": "Einmalige Ausgabe",
    "subscriptions": "Abonnements",
    "standard_reimbursement": "Standarderstattung",
    "hospitality_reimbursement": "Bewirtungserstattung",
    "mileage_reimbursement": "Kilometererstattung",
    "per_diem_reimbursement": "Tagesgelderstattung",
    "sync_updates": "Synchronisieren",
    "fiscal_year": {
        "start": "Von",
        "end": "Bis"
    },
    "datev_csv_config": {
        "wallet_account": "finway Wallet Konto",
        "cash_transit_account": "Geldtransitkonto",
        "account_length": "Länge der Kontonummer"
    },
    "datev_client_and_consultant": {
        "client_number": "Mandantennummer",
        "consultant_number": "Beraternummer"
    }
}
